import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const People = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = '#1E88E5', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill="none"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M18.9307 7.66C18.8707 7.65 18.8007 7.65 18.7407 7.66C17.3607 7.61 16.2607 6.48 16.2607 5.08C16.2607 3.65 17.4107 2.5 18.8407 2.5C20.2707 2.5 21.4207 3.66 21.4207 5.08C21.4107 6.48 20.3107 7.61 18.9307 7.66Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M17.9006 14.9399C19.2706 15.1699 20.7806 14.9299 21.8406 14.2199C23.2506 13.2799 23.2506 11.7399 21.8406 10.7999C20.7706 10.0899 19.2406 9.84991 17.8706 10.0899"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M6.90065 7.66C6.96065 7.65 7.03064 7.65 7.09064 7.66C8.47064 7.61 9.57064 6.48 9.57064 5.08C9.57064 3.65 8.42065 2.5 6.99065 2.5C5.56065 2.5 4.41064 3.66 4.41064 5.08C4.42064 6.48 5.52065 7.61 6.90065 7.66Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M7.9306 14.9399C6.5606 15.1699 5.05061 14.9299 3.99061 14.2199C2.58061 13.2799 2.58061 11.7399 3.99061 10.7999C5.06061 10.0899 6.5906 9.84991 7.9606 10.0899"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9332 15.13C12.8732 15.12 12.8032 15.12 12.7432 15.13C11.3632 15.08 10.2632 13.95 10.2632 12.55C10.2632 11.12 11.4132 9.96997 12.8432 9.96997C14.2732 9.96997 15.4232 11.13 15.4232 12.55C15.4132 13.95 14.3132 15.09 12.9332 15.13Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0233 18.2799C8.61332 19.2199 8.61332 20.7599 10.0233 21.6999C11.6233 22.7699 14.2433 22.7699 15.8433 21.6999C17.2533 20.7599 17.2533 19.2199 15.8433 18.2799C14.2533 17.2199 11.6233 17.2199 10.0233 18.2799Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

People.displayName = 'People';
